<template>
	<article class="tcp-card">
		<router-link :to="'/product/' + product.id" class="tcp-card__media">
			<img v-if="product.image_url" :src="product.image_url" :alt="product.name">
			<span v-else class="tcp-card__placeholder"><i class="fa fa-box"></i></span>
			<span v-if="!available" class="tcp-card__badge">Sold out</span>
		</router-link>
		<div class="tcp-card__body">
			<router-link :to="'/product/' + product.id" class="tcp-card__name">{{ product.name }}</router-link>
			<p v-if="product.presentation" class="tcp-card__meta">{{ product.presentation }}</p>
			<div class="tcp-card__row">
				<strong>{{ money(product.price) }}</strong>
				<button type="button" class="tcp-btn tcp-btn--small" :disabled="!available" @click="add">
					{{ available ? 'Add' : 'Sold out' }}
				</button>
			</div>
		</div>
	</article>
</template>

<script>
export default {
	props: {
		product: { type: Object, required: true }
	},
	computed: {
		available() {
			return Number(this.product.stock) > 0 && this.product.status !== 'Agotado'
		}
	},
	methods: {
		money(value) {
			return '$' + Number(value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
		},
		add() {
			if (!this.available) return
			this.$cart.add(this.product, 1)
		}
	}
}
</script>
